import { useEffect } from "react";
import { SettingsSidebar } from "@/components/settings";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useChatContext } from "@/stores/chat-context-store";
import { useTranslation } from "@/packages/utils";
import { useWorkspace } from "../route";

export const Route = createFileRoute("/$workspaceSlug/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  const { t } = useTranslation(["settings"]);
  const { workspaceSlug } = useWorkspace();
  const setAmbientContext = useChatContext((s) => s.setAmbientContext);
  const clearAmbientContext = useChatContext((s) => s.clearAmbientContext);

  useEffect(() => {
    setAmbientContext({
      page: "settings",
      label: t("settings:title") as string,
    });
    return () => clearAmbientContext();
  }, [setAmbientContext, clearAmbientContext, t]);

  return (
    <div className="w-full px-2 pb-2 pt-5 sm:px-3 lg:min-h-full lg:px-3">
      <div className="mx-auto max-w-[1220px]">
        <div className="rounded-[30px] border border-white/70 bg-[linear-gradient(180deg,rgba(255,255,255,0.78),rgba(255,255,255,0.72))] p-3 shadow-[0_20px_60px_-30px_rgba(15,23,42,0.25)] backdrop-blur-lg sm:p-4 lg:flex lg:h-[calc(100vh-3rem)] lg:min-h-0 lg:flex-col lg:p-5">
          <div className="flex flex-col gap-6 lg:min-h-0 lg:flex-1 lg:flex-row lg:gap-8">
            <SettingsSidebar workspaceSlug={workspaceSlug} />
            <div className="min-w-0 flex-1 pb-3 lg:min-h-0 lg:overflow-y-auto lg:pb-6 slim-scroll">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
